import { render, staticRenderFns } from "./company-build-course.vue?vue&type=template&id=2c0705b6&"
import script from "./company-build-course.vue?vue&type=script&lang=js&"
export * from "./company-build-course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports